import React, { useEffect, useState, useRef } from "react";
import BlackHeader from "../Layout/BlackHeader/BlackHeader";
import styles from "./Disclaimer.module.scss";
import Footer from "../Layout/Footer/Footer";
import useLocoScroll from "../../hooks/useLocoScroll";
import useOnScreen from "../../hooks/useOnScreen";
import img from "../../Assets/lrc-investment-lifecycle.png";
import MetaDecorator from "../Util/MetaDecorator";
export default function Disclaimer() {
	useLocoScroll(true);
	const ref = useRef(null);

	const [reveal, setReveal] = useState(false);
	const onScreen = useOnScreen(ref);

	useEffect(() => {
		if (onScreen) setReveal(onScreen);
	}, [onScreen]);
	return (
		<>
		<MetaDecorator
						title={"LRC Group | Responsible Investment Policy"}
						description={
							"We are very delighted that you have shown interest in our enterprise. Data protection is of a particularly high priority for the management of the LRC Group. The use of the Internet pages of the LRC Group is possible without any indication of personal data; however, if a data subject wants to use special enterprise services via our website, processing of personal data could become necessary."
						}
					/>
			<div className="sticky-header">
				<BlackHeader />
			</div>
			<div
				id="main-container"
				data-scroll-container>
				<section
					className={styles.DisclaimerAlignment}
					data-scroll-section>
					<div className="container">
						<div className={styles.boxCenterAlignment}>
							<div className={styles.boxWidth}>
								<div className={styles.pageTitle}>
									<h1>Responsible Investment Policy</h1>
								</div>
								<div className={styles.subTextAlignment}>
									<h2>Responsible Investment Policy</h2>
									<p>
										This Responsible Investment Policy forms the cornerstone of
										the LRC Groups efforts to assimilate sustainability and ESG
										into the way we do business. We do this by;
									</p>
									<ul>
										<li>
											Integrating all relevant ESG factors into our investment
											processes
										</li>
										<li>Being ESG proactive</li>
										<li>
											Actively engaging with our stakeholders to ensure
											adherence to our ESG expectations
										</li>
										<li>
											Reporting on all ESG matters in compliance with
											international norms
										</li>
									</ul>
									<p>
										We are mindful that our investment performance (Financial
										Materiality) is affected by sustainability factors and also
										the impact on society (Environmental and Social Materiality)
										that our investments may cause, both positive and negative –
										this is commonly referred to as “Double Materiality”
										considerations.
									</p>
									<h2>LRC Investment Lifecycle</h2>
									<p>
										The LRC Group has, where relevant, integrated ESG throughout
										the investment lifecycle. This has seen us incorporate ESG
										specific items at each stage from pre-acquisition
										(pre-screening & due diligence), through to holding the
										asset(s) and then to exit. A summary of this lifecycle can
										be seen below.
									</p>
									<img
										src={img}
										style={{ width: "100%", height: "auto" }}
										alt=""
									/>
									<h2>LRC ESG Program</h2>
									<p>
										Our ESG program is rooted in the principles of monitoring,
										measuring and managing all of the ESG touchpoints throughout
										the Group and throughout the investment lifecycle.
									</p>
									<ul>
										<li>
											<b>Monitor</b> – have sufficient processes, procedures and
											systems in place to capture all ESG relevant data
										</li>
										<li>
											<b>Measure</b> – having captured the data we then turn it
											into usable and actionable data
										</li>
										<li>
											<b>Manage</b> – this data is then used to manage our ESG
											commitments
										</li>
									</ul>
									<h2>Reporting and transparency</h2>
									<p>
										We regularly report on issues of ESG relevance primarily via
										our website and through fund specific Annual Reports. In
										addition, if relevant, ESG specific items can be disclosed
										and reported directly to investors and other stakeholders.
										The LRC Group supports standardised and integrated
										reporting, which incorporates material sustainability
										information with financial information and provides
										consistent and comparable ESG data. We also support the
										adoption of the recommendations of the Task Force on
										Climate-related Financial Disclosures (“TCFD”). Our
										disclosure statement on the consideration of PAI at
										entity-level can be found on our website. The PAI of our
										investments is reported annually in this statement. In
										addition we report on issues of ESG relevance through our
										website and through the PRI reporting framework.
									</p>
									<h2>Data & Technology</h2>
									<p>
										Utilising various technology solutions we seek to harness
										the large volume of ESG related data/dataset to support and
										optimise our investment approach, due diligence, asset
										acquisition and asset ownership.
									</p>
									<h2>LRC teams and the use of ESG data</h2>
									<p>
										We believe that integrating ESG data into the acquisition,
										portfolio management and asset management processes across
										our business enables us to generate superior returns and
										drive positive change at the same time.
									</p>
									<ul>
										<li>
											<b>Acquisition team</b> – Considering ESG data in
											Investment/acquisition research and due diligence allows
											greater insights into the risks and long-term value of
											potential acquisitions.
										</li>
										<li>
											<b>Portfolio Management team</b> - Considering ESG
											analysis and insights into portfolio decisions allows
											portfolio management to better manage potential risks and
											identify potential opportunities.
										</li>
										<li>
											<b>Asset management team</b> - Being active owners of our
											assets allows us to actively manage potential risks and
											maximise the benefit of ESG related activities and
											initiatives.
										</li>
									</ul>
									<h2>Good governance</h2>
									<p>
										The LRC Group strongly believes in the principles of good
										governance and, as such, has implemented a full suite of
										Group policies applicable to all staff and in specific
										instances to third party suppliers and stakeholders.
										<br /> We have also developed policies and procedures to
										ensure that our investments meet our expectations of ESG
										performance and that ESG/sustainability risk is managed
										throughout our investment processes and the investment
										lifecycle.
										<br /> Our responsible investment approach builds on the PRI
										guidelines.
										<br /> This is supported by our principal adverse impact
										(“PAI”) analysis. Principal adverse impact at entity-level
										is reported annually, in accordance with the EU SFDR
										requirements.
										<br /> In some instances we may rely on one or more external
										providers of ESG data (as well as our own internal sources
										of data). These data providers and other data sources are
										assessed on an ongoing basis for data quality, timeliness,
										coverage and other attributes. The environmental and social
										impact of our investments is monitored on an ongoing basis,
										subject to data availability.
									</p>
									<h2>Principal Adverse Impacts</h2>
									<p>
										Principal Adverse Impacts are negative impacts on
										sustainability – for example; carbon emissions, waste,
										fossil fuel exposure, gender diversity, corruption, bribery,
										etc. The LRC Group strives to manage these impacts through
										sustainability-relevant policies and procedures.
										<br /> We identify Principal Adverse Impacts through
										screening of Environmental and Social materiality. This
										screening focuses on a core set of mandatory indicators that
										always lead to Principal Adverse Impacts. Subject to data
										availability, our selection of Principal Adverse Impact
										indicators follows the methodology of selecting the
										indicators which are relevant to consider based on the
										nature of our business activities.
									</p>
									<h2>Stakeholders</h2>
									<p>
										The LRC Group seeks to actively engage with our stakeholders
										(employees, investors, regulators, suppliers, etc) on all
										matters relating to ESG, specifically to inform on ESG risk
										factors and incorporate these items into our investment
										approach. We strive to be good neighbours, and to enrich all
										of the communities in which we live, work and invest.
									</p>
									<h2>Conflicts of interest</h2>
									<p>
										The LRC Group is aware that potential or actual conflicts of
										interests may arise as part of our normal day to day
										activities. As such, the LRC Group has implemented policies
										to prevent conflicts of interest arising, if at all
										possible.
										<br /> In the event that such conflicts cannot be avoided,
										we will identify, manage and monitor the conflicts and, if
										appropriate, disclose them to all relevant stakeholders.
									</p>
									<h2>Sustainability</h2>
									<p>
										The LRC Group is committed to integrating sustainability
										into all relevant processes in all business areas. We take
										all relevant environmental, social and governance principles
										into consideration when evaluating business opportunities
										and risks. We adhere to the following principles and we
										expect suppliers and business partners to do so as well;
									</p>
									<ul>
										<li>Good corporate citizenship</li>
										<li>Ethics, honesty and sincerity</li>
										<li>Rejection of bribery and corruption</li>
										<li>Equal opportunities and diversity</li>
										<li>Employee wellbeing</li>
										<li>Human and Labour rights</li>
										<li>Caring for the environment</li>
									</ul>
									<h2>Biodiversity</h2>
									<p>
										The LRC Group recognises that nature is being eroded at
										unprecedented rates, resulting in the irreversible loss of
										both habitats and plant & animal species. We, therefore,
										include Biodiversity as one of the risk factors assessed in
										our pre-acquisition due diligence. Post acquisition, we
										continually assess how we can enhance and increase
										biodiversity across the assets we own and manage.
									</p>
									<h2>Climate change</h2>
									<p>
										The LRC Group views climate change as one of the largest
										threats to life on earth and to the global economy. We are
										working on an ongoing basis to assess climate change risks
										in our investments and the impact low-carbon transition.
										Climate change presents a risk to our investments – in terms
										of physical risk, policy risk, consumer/tenant risk and
										transition risk (reducing greenhouse gas emissions).
										<br /> The LRC Group has a long-term strategic objective to
										reduce the greenhouse gas emissions impact of our
										investments and business in line with the “well below 2°C”
										ambition and to ensure that our investment portfolios are
										resilient to climate-related risks.
										<br /> The LRC Group aims to comply with international
										conventions and norms, including, but not limited to the
										following:
									</p>
									<ul style={{ listStyle: "none" }}>
										<li>
											- United Nations Global Compact OECD Principles of
											Corporate
										</li>
										<li>
											- Governance Universal Declaration of Human Rights UN
										</li>
										<li>
											- Guiding Principles on Business and Human Rights
											Children’s
										</li>
										<li>
											- Rights and Business Principles UN Convention on
											Corruption
										</li>
									</ul>
									<h2>Human Rights</h2>
									<p>
										The LRC Group is committed to remaining in compliance with
										all Human Rights legislation in the various jurisdictions in
										which it operates. We expect all companies within our supply
										chain to be in similar compliance. Human rights-related
										issues include but is not limited to human rights abuses,
										modern slavery, fair living wage, child labour, occupational
										safety and health and international humanitarian law.
									</p>
								</div>
							</div>
						</div>
					</div>
				</section>
				<>
					<Footer />
				</>
				<div className="footerBottomAlignment"></div>
			</div>
		</>
	);
}
